/**
 * Underline-style tab list.
 * items: [{ id, label }]
 */
export function Tabs({ items = [], value, onChange, className = '' }) {
  return (
    <div
      className={`flex items-center gap-1 border-b border-border-default ${className}`}
      role="tablist"
    >
      {items.map((item) => {
        const active = value === item.id;
        return (
          <button
            key={item.id}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange?.(item.id)}
            className={`px-4 py-2.5 text-sm font-semibold transition-colors relative ${
              active
                ? 'text-primary'
                : 'text-text-muted hover:text-text-primary'
            }`}
          >
            {item.label}
            {active && (
              <span className="absolute left-0 right-0 -bottom-px h-0.5 bg-primary rounded-full" />
            )}
          </button>
        );
      })}
    </div>
  );
}
